import React from 'react';
import { Modal } from 'react-bootstrap';
import { DiscountForm } from './DiscountForm';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './DiscountModal.css';

export default function DiscountModal({ show, onClose, siteData }) {
    return (
        <Modal show={show} onHide={onClose} centered dialogClassName="discount-modal-dialog">
            <Modal.Header className="border-0 pb-0 pt-8">
                <h2 className="text-center w-100 pt-1 px-3 modal-title pb-0">Get 50% off</h2>
            </Modal.Header>
            <Modal.Body className="discount-modal-body text-center p-0 pt-1">
                <h5 className="mb-2 modal-subheader">When you sign up for emails and texts</h5>
                <GoogleReCaptchaProvider
                    reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
                    scriptProps={{ async: true }}
                >
                    <DiscountForm onClose={onClose} siteData={siteData} />
                </GoogleReCaptchaProvider>
            </Modal.Body>
            <Modal.Footer className="d-flex flex-column border-0">
                <button type="button" className="exit-btn mb-3 w-100" onClick={onClose}>
                    No thanks
                </button>
            </Modal.Footer>
        </Modal>
    );
}
